{
    "tapi_integration__no_phone": "No phone number provided",
    "tapi_integration__usage": "Usage: /integrations/tapi/[phone-number]",
    "tapi_integration__error": "Error looking up phone number",
    "tapi_integration__looking_up": "Searching for phone number",
    "tapi_integration__no_match": "No customer found for phone number:",
    "tapi_integration__no_match_help": "The phone number may not be registered in the system, or the format may not match."
}
